export const getHTMLRemovedQuestion = (HTMLQuestion) => {
    return (HTMLQuestion.replace(/<[^>]*>?/gm, '')).replace(/&nbsp;/gm, ' ');
}